import {
    AMC_FORM_VALID_TRANSITION_BASIC_DETAILS,
    AMC_FORM_INVALID_TRANSITION_BASIC_DETAILS,
    AMC_BASIC_DETAILS_SET_VALUE,
    AMC_BASIC_DETAILS_SET_VALID,
    AMC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION,
    AMC_BASIC_DETAILS_EDIT
} from '../../actions/allSureMotorClaim/basicDetails';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initBasicDetails = {
    formStatus: FORM_STATUS.INVALID,
    isBasicDetailsEdit: false,
    form: {
        categoryType: { value: null, error: null, status: null ,displayValue: null},
        policyNumber: { value: null, error: null, status: null ,displayValue: null},
        fullName: { value: null, error: null, status: null ,displayValue: null},     
        mobileNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        privacyNotice: { value: null, error: null, status: null ,displayValue: null},
        tnc: { value: null, error: null, status: null ,displayValue: null},
        consentNotice: { value: null, error: null, status: null ,displayValue: null},
    },
};
export default (state = initBasicDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
    switch (action.type) {
        case AMC_FORM_VALID_TRANSITION_BASIC_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case AMC_FORM_INVALID_TRANSITION_BASIC_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case AMC_BASIC_DETAILS_SET_VALUE:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                value: action.value.value,
                displayValue: action.value.displayValue
            }));
        case AMC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                value: action.value.value,
                displayValue: action.value.value,
                error: null,
                status: null,
            }));

        case AMC_BASIC_DETAILS_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: error,
                status: mapError(error),
            }));
        case AMC_BASIC_DETAILS_EDIT:
            return { ...state, isBasicDetailsEdit: action.value };
        default:
            return state;
        // }
    }
};
